export const runGoogleReCaptcha = (token, callback, onReject) => {
    var _a;
    (_a = window.grecaptcha) === null || _a === void 0 ? void 0 : _a.ready(function () {
        window.grecaptcha.execute(token, { action: `submit` }).then(callback, onReject);
    });
};
export const getGoogleReCaptchaToken = (token) => {
    return new Promise((resolve, reject) => {
        runGoogleReCaptcha(token, resolve, reject);
    });
};
//# sourceMappingURL=runGoogleReCaptcha.js.map